import { Component, OnInit, Optional } from "@angular/core";
import { SystemService } from "@root/router/system/system.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { postMsg } from "@root/router/public/h5/channel/util";
import { isMobileDevice } from "@root/util/util";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "v4-connect-with-airbnb",
  templateUrl: "./connect-with-airbnb.component.html",
  styleUrls: ["./connect-with-airbnb.component.scss"],
})
export class V4ConnectWithAirbnbComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;

  authUrl;

  constructor(
    @Optional() private modalRef: NzModalRef,
    private system: SystemService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.fetchAuthUrl();
  }

  toOuterLink() {
    const url = "https://www.airbnb.com/help/article/1857";
    if (isMobileDevice()) {
      postMsg("OUT_LINK", {
        url: url,
      });
    } else {
      window.open(url, "_blank");
    }
  }

  onCancel() {
    if (isMobileDevice()) {
      postMsg("BACK");
    } else {
      this.modalRef.destroy();
    }
    // this.modalRef.destroy();
  }

  onAuth() {
    console.log("url: ", this.system.oauthUrl);
    // const url = this.system.oauthUrl.airbnb;
    window.open(this.authUrl);
    this.modalRef?.destroy();
  }

  private fetchAuthUrl() {
    this.http.get("/api/config/init").subscribe((rst: any) => {
      this.authUrl = rst?.data?.oauth_url?.airbnb;
    });
  }
}
